import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { FORGET_PASS } from '../helpers/api'

function ForgetPassword() {

    const [data, setData] = useState({ email: "" })

    const handleemail = (e) => {
        setData({ ...data, email: e.target.value })
    }

    const forgetpass = async () => {
        try {
            const payload = {
                email: data.email
            }

            const response = await FORGET_PASS(payload)
            if (response.success) {
                alert("otp sent to your email")
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    return (
        <>
            <section className='forget_sec'>
                <div className="container">
                    <div className="card jc-center">
                        <h3 className='mb-5'>Forget Password</h3>
                            <div className="mb-5">
                                <label className="form-label mb-2">Email</label>
                                <input type="email" onChange={(e) => handleemail(e)} className="form-control" placeholder='Enter here' required />
                            </div>
                            <div className="mb-3">
                                <button onClick={() => forgetpass()} className="btn sign_btn">Update</button>
                            </div>
                            <small>Go Back to &nbsp; <Link to="/sign-in"> Sign In</Link></small>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ForgetPassword
